import { useNavigate, useSearch } from "@tanstack/react-router";
import { TimeScreen } from "@/components/time/TimeScreen";
import type { TimeSearch } from "@/schemas/time";

/** /dashboard/time: week, view and open dialog all live in the URL (src/schemas/time.ts). */
export function TimePage() {
  const search = useSearch({ from: "/dashboard/time" });
  const navigate = useNavigate({ from: "/dashboard/time" });
  return (
    <TimeScreen
      search={search}
      onSearchChange={(next: Partial<TimeSearch>, replace = false) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }), replace })
      }
    />
  );
}
